import type { DiscoverTrack, Track } from '@/types';

/**
 * Map a feed `DiscoverTrack` to the `Track` shape used by the reco flow /
 * backend payload. Ported from the legacy `racoreMapper`.
 */
export const mapDiscoverTrackToTrack = (d: DiscoverTrack): Track => {
  const image = d.metadata?.big_illustration_url || d.main_illustration_url || undefined;
  return {
    id: String(d.id),
    isrc: d.isrc,
    title: d.title,
    artists: (d.artists ?? []).map((a) => ({ id: String(a.id), name: a.name })),
    previewUrl: d.metadata?.preview_url || undefined,
    durationMs: d.duration_ms,
    is_explicit: d.explicit,
    bpm: d.metadata?.bpm,
    album: {
      id: '',
      name: '',
      image: image,
      image_xl: image,
      release_date: d.release_date,
    },
  };
};
